import React from 'react';
import styled from "styled-components";
import AssetSvg from "./components/AssetSvg";
import SudowriteLogo from "./components/SudowriteLogo";
import { Link } from "react-router-dom";
import usePublicMode from "./hooks/usePublicMode";

const StyledSvg = styled(AssetSvg)`
  color: var(--grey-0);
`;

const StyledMessage = styled.h2`
  color: var(--grey-0);
`;

const StyledLink = styled(Link)`
  color: var(--grey-0) !important;
`;

export default function PageNotFound(props) {
  const { urlPrefixApp } = usePublicMode();

  let message = props.message || "This page does not exist.";

  return (
    <>
      {!props.disableHeader && (
        <div
          id="menu"
          className="flexible"
        >
          <div className="inner">
            <h1>
              <SudowriteLogo
                className="logo"
                isLink
                size="large"
              />
            </h1>
          </div>
        </div>
      )}

      <div className="not-found">
        <div className="clouds">
          <StyledSvg
            className="logo"
            src="not-found.svg"
          />
        </div>

        <StyledMessage>{message}</StyledMessage>

        <StyledLink to={`${urlPrefixApp}`}>View all projects</StyledLink>
      </div>
    </>
  );
}
